<template>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header card-gis-filter">
        <div class="row p-3">
          <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3">
            <label>{{ $t('common_words.farm') }} *</label>
            <br />
            <el-select
              id="farm_pruning_catching"
              clearable
              v-bind:collapse-tags="true"
              filterable
              class="select-primary custom-width-select required-farm shadow-sm"
              size="large"
              @change="handlehange"
              v-model="catchingForm.farm_id"
              :placeholder="`${$t('common_words.select')}...`"
            >
              <el-option
                v-for="(option, index) in farms"
                class="select-primary"
                :value="option.id"
                :label="option.name"
                :key="index + option.id"
              ></el-option>
            </el-select>
          </div>
          <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3">
            <label>{{ $t('common_words.year') }} *</label>
            <br />
            <el-select
              id="year_pruning_catching"
              clearable
              filterable
              @change="handlehange"
              class="select-primary custom-width-select required-year shadow-sm"
              size="large"
              v-model="catchingForm.year"
            >
              <el-option
                v-for="(option, index) in years"
                class="select-primary"
                :value="option"
                :label="option"
                :key="index"
              ></el-option>
            </el-select>
          </div>
          <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3">
            <label>{{ $t('common_words.week') }} *</label>
            <br />
            <el-select
              id="week_pruning_catching"
              clearable
              filterable
              @change="handlehange"
              class="select-primary custom-width-select required-year shadow-sm"
              size="large"
              v-model="catchingForm.week"
            >
              <el-option
                v-for="(option, index) in weeks"
                class="select-primary"
                :value="option"
                :label="option"
                :key="index"
              ></el-option>
            </el-select>
          </div>
          <div class="col-12 col-md-4 col-xl-2">
            <label class="label-primary" style="color: transparent">{{
              $t('common_words.filter')
            }}</label
            ><br />
            <l-button wide type="info" class="btn-filter" @click="validate">
              {{ $t('common_words.generate') }}
            </l-button>
          </div>
        </div>
      </card>
      <br />
      <card
        class="custom-shadow-card-header custom-table-responsive"
        v-if="catching && catchingData.data.length > 0"
      >
        <div class="mt-4">
          <div class="row" v-if="isIndex() && (isCreate() || isUpdate())">
            <div class="table-responsive">
              <div class="custom-flex">
                <el-select
                  clearable
                  v-bind:collapse-tags="true"
                  filterable
                  class="select-primary custom-width-select required-farm mb-3 shadow-sm"
                  size="large"
                  v-model="catchingForm.reason_id"
                  :placeholder="`${$t('production.motive_selection')}...`"
                >
                  <el-option
                    v-for="(reason, index) in reasons"
                    class="select-primary"
                    :value="reason.reason_id"
                    :label="reason.name"
                    :key="index"
                  ></el-option>
                </el-select>
              </div>

              <table class="table table-striped table-bordered not-last-td">
                <thead>
                  <tr class="cusmtom-thead-color">
                    <th
                      scope="col"
                      class="text-center p-3 custom-header-label"
                      v-bind:style="{ minWidth: '100px' }"
                    >
                      <strong>{{ $t('common_words.allotment') }}</strong>
                    </th>
                    <th scope="col" class="text-center p-3 custom-header-label">
                      {{ $t('sowing.sowing_week') }}
                    </th>
                    <th scope="col" class="text-center p-3 custom-header-label">
                      {{ $t('sowing.prunning_available_area') }} (ha)
                    </th>
                    <th scope="col" class="text-center p-3 custom-header-label">
                      {{ $t('sowing.prune_area') }} (ha)
                    </th>
                    <th scope="col" class="text-center p-3 custom-header-label">
                      {{ $t('common_words.plants_quantity') }}
                    </th>
                    <th scope="col" class="text-center p-3 custom-header-label">
                      {{ $t('common_words.variety') }}
                    </th>
                    <th scope="col" class="text-center p-3 custom-header-label">
                      {{ $t('production.bagged_week') }}
                    </th>
                    <th scope="col" class="text-center p-3 custom-header-label">
                      {{ $t('production.harvest_week') }}
                    </th>
                    <th
                      scope="col"
                      class="text-center custom-header-label"
                      v-bind:style="{ width: '100px', marginTop: '6px' }"
                    >
                      <strong>{{ $t('common_words.options') }}</strong>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(lot, i) in nCatching" :key="i">
                    <td class="text-center">
                      <el-select
                        :disabled="
                          catchingData.data[i].week_seeding ==
                          parseInt(catchingForm.year) * 100 +
                            parseInt(catchingForm.week)
                            ? true
                            : false
                        "
                        clearable
                        filterable
                        width="10"
                        class="select-primary custom-width-select required-lots shadow-sm"
                        size="medium"
                        v-model="catchingData.data[i].lot_name"
                        :placeholder="`${$t('common_words.select')}...`"
                        @change="onSelectLot($event, i)"
                        value-key="id"
                      >
                        <el-option
                          v-for="l in availableLots"
                          class="select-primary"
                          :value="l"
                          :label="l.name"
                          :key="l.id"
                        ></el-option>
                      </el-select>
                    </td>
                    <td class="text-center">
                      {{ catchingData.data[i].week_seeding }}
                    </td>
                    <td class="text-center">
                      {{
                        catchingData.data[i].area_disponible_aux
                          ? catchingData.data[i].area_disponible_aux
                          : catchingData.data[i].area_disponible
                      }}
                    </td>
                    <td class="text-center">
                      <el-input
                        :disabled="
                          (catchingData.data[i].week_pruning ==
                          parseInt(catchingForm.year) * 100 +
                            parseInt(catchingForm.week)
                            ? true
                            : false) ||
                          catchingData.data[i].area_disponible <= 0
                        "
                        clearable
                        maxlength="5"
                        class="text-center"
                        v-model="catchingData.data[i].area_podar"
                        @change="
                          onChangeAreaInput(
                            $event,
                            i,
                            catchingData.data[i].lot_name
                          )
                        "
                      />
                    </td>

                    <td class="text-center">
                      <el-input
                        :disabled="
                          catchingData.data[i].week_pruning ==
                          parseInt(catchingForm.year) * 100 +
                            parseInt(catchingForm.week)
                            ? true
                            : false
                        "
                        clearable
                        class="text-center"
                        v-model="catchingData.data[i].plants_number"
                      />
                    </td>

                    <td class="text-center">
                      <el-select
                        :disabled="
                          catchingData.data[i].week_pruning ==
                          parseInt(catchingForm.year) * 100 +
                            parseInt(catchingForm.week)
                            ? true
                            : false
                        "
                        clearable
                        filterable
                        width="10"
                        class="select-primary custom-width-select required-lots shadow-sm"
                        size="medium"
                        :id="`variety${i}`"
                        v-model="catchingData.data[i].variety"
                        :placeholder="`${$t('common_words.select')}...`"
                        @change="onSelectVariety($event, i)"
                        value-key="id"
                      >
                        <el-option
                          v-for="(variety, index) in varieties"
                          class="select-primary"
                          :value="variety"
                          :label="variety.name"
                          :key="index"
                        ></el-option>
                      </el-select>
                    </td>

                    <td class="text-center">
                      <el-select
                        :disabled="
                          catchingData.data[i].week_pruning ==
                          parseInt(catchingForm.year) * 100 +
                            parseInt(catchingForm.week)
                            ? true
                            : false
                        "
                        :id="`pocket_year${i}`"
                        clearable
                        filterable
                        class="select-primary custom-width-select required-year shadow-sm"
                        size="large"
                        v-model="catchingData.data[i].pocket_year"
                        :placeholder="`${$t('common_words.year')}...`"
                      >
                        <el-option
                          v-for="(option, index) in years"
                          class="select-primary"
                          :value="option"
                          :label="option"
                          :key="index"
                        ></el-option>
                      </el-select>
                      <br />
                      <el-select
                        :disabled="
                          catchingData.data[i].week_pruning ==
                          parseInt(catchingForm.year) * 100 +
                            parseInt(catchingForm.week)
                            ? true
                            : false
                        "
                        clearable
                        filterable
                        width="10"
                        class="select-primary custom-width-select required-lots shadow-sm"
                        size="medium"
                        :id="`pocket_week${i}`"
                        v-model="catchingData.data[i].pocket_week"
                        :placeholder="`${$t('common_words.week')}...`"
                      >
                        <el-option
                          v-for="(w, index) in weeks"
                          class="select-primary"
                          :value="w"
                          :label="w"
                          :key="index"
                        ></el-option>
                      </el-select>
                    </td>

                    <td class="text-center">
                      <el-select
                        :disabled="
                          catchingData.data[i].week_pruning ==
                          parseInt(catchingForm.year) * 100 +
                            parseInt(catchingForm.week)
                            ? true
                            : false
                        "
                        :id="`production_year${i}`"
                        clearable
                        filterable
                        class="select-primary custom-width-select required-year shadow-sm"
                        size="large"
                        v-model="catchingData.data[i].production_year"
                        :placeholder="`${$t('common_words.year')}...`"
                      >
                        <el-option
                          v-for="(option, index) in years"
                          class="select-primary"
                          :value="option"
                          :label="option"
                          :key="index"
                        ></el-option>
                      </el-select>
                      <br />
                      <el-select
                        :disabled="
                          catchingData.data[i].week_pruning ==
                          parseInt(catchingForm.year) * 100 +
                            parseInt(catchingForm.week)
                            ? true
                            : false
                        "
                        clearable
                        filterable
                        width="10"
                        class="select-primary custom-width-select required-lots shadow-sm"
                        size="medium"
                        :id="`production_week${i}`"
                        v-model="catchingData.data[i].production_week"
                        :placeholder="`${$t('common_words.week')}...`"
                      >
                        <el-option
                          v-for="(w, index) in weeks"
                          class="select-primary"
                          :value="w"
                          :label="w"
                          :key="index"
                        ></el-option>
                      </el-select>
                    </td>

                    <td
                      class="text-center"
                      style="display: table-cell"
                      v-bind:style="{ width: '100px' }"
                    >
                      <div class="d-flex justify-content-center mt-3">
                        <!-- <a v-if="isUpdate()"
                                      v-tooltip.top-center="'Agregar'"
                                      class="btn-warning btn-simple btn-link custom-margin-actions"
                                      @click.prevent="addLotData()"
                                    >
                                      <em class="fa fa-plus custom-size-fa-actions"></em>
                                    </a> -->
                        <a
                          v-if="nCatching > 1 && isDelete()"
                          v-tooltip.top-center="$t('common_words.erase')"
                          class="btn-danger btn-simple btn-link custom-margin-actions"
                          @click="handleDelete(i)"
                        >
                          <em class="fa fa-times custom-size-fa-actions"></em>
                        </a>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="row">
            <div class="col-6 text-right" v-if="isCreate() || isUpdate()">
              <l-button
                wide
                type="info"
                class="btn-filter m-4"
                v-on:click="validateData()"
              >
                {{ $t('common_words.save') }}
              </l-button>
            </div>
            <div class="col-6 text-left" v-if="isDelete()">
              <l-button
                wide
                type="danger"
                class="btn-filter m-4"
                @click="deleteAll()"
              >
                {{ $t('common_words.delete') }}
              </l-button>
            </div>
          </div>
        </div>
      </card>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import store from '@/store';
import { mapActions } from 'vuex';
import mixinMasters from 'src/util/mixinMasters';
import MixinPermissions from 'src/util/mixinPermissions';
import SweetAlert from 'src/class/Alerts';
import { Axios } from 'src/class/Axios.js';
import MixinMenu from 'src/util/mixinMenu';

export default {
  data() {
    return {
      farms: [],
      catchingForm: {
        farm_id: null,
        year: null,
        week: null,
        reason_id: null,
      },
      catchingData: {
        data: [],
      },

      lots_sel: [],
      years: [],
      weeks: [],
      varieties: [],
      catching: false,
      nCatching: 0,
      lots: [],
      reasons: [],
    };
  },

  mixins: [MixinPermissions, mixinMasters, MixinMenu],

  computed: {
    availableLots() {
      return this.lots.filter((lot) => !this.lots_sel.includes(lot.id));
    },
  },

  methods: {
    ...mapActions({
      validationInputsRequired: 'utils/validationInputsRequired',
    }),

    handleChangeVariety(index) {
      let input = document.getElementById(`variety${index}`);
      input.classList.remove('custom-has-error');
    },

    handleChangePocket(index) {
      let input = document.getElementById(`pocket_week${index}`);
      input.classList.remove('custom-has-error');
    },

    handleChangeProduction(index) {
      let input = document.getElementById(`production_week${index}`);
      input.classList.remove('custom-has-error');
    },

    handleDelete(index) {
      this.catchingData.data[index]['poda_completa'] = null;
      this.catchingData.data[index]['area_podar'] = null;
      this.catchingData.data[index]['variety'] = null;
      this.catchingData.data[index]['pocket_week'] = null;
      this.catchingData.data[index]['production_week'] = null;
      this.catchingData.data[index]['area_disponible_aux'] =
        this.catchingData.data[index]['area_disponible'];
    },

    handlehange() {
      this.catching = false;
    },

    addLotData() {
      this.catchingData.data.push({
        lot_id: null,
        lot_name: null,
        area_lote: null,
        area_disponible: null,
        pruning_week: null,
        area_podar: null,
      });
      this.nCatching++;
    },

    validate() {
      return this.$validator.validateAll().then((response) => {
        if (!this.catchingForm.farm_id) {
          let sel = document.getElementById('farm_pruning_catching');
          sel.focus();
          sel.classList.add('custom-has-error');
          store.dispatch('utils/removeHasError', sel);
          return false;
        }
        if (!this.catchingForm.year) {
          let sel = document.getElementById('year_pruning_catching');
          sel.focus();
          sel.classList.add('custom-has-error');
          store.dispatch('utils/removeHasError', sel);
          return false;
        }
        if (!this.catchingForm.week) {
          let sel = document.getElementById('week_pruning_catching');
          sel.focus();
          sel.classList.add('custom-has-error');
          store.dispatch('utils/removeHasError', sel);
          return false;
        }

        this.loadPruning();
      });
    },

    storeCatching() {
      let data = {
        route: 'pruning/catching/store',
        farm_id: this.catchingForm.farm_id,
        date:
          parseInt(this.catchingForm.year) * 100 +
          parseInt(this.catchingForm.week),
        catchingData: this.catchingData.data,
        year: this.catchingForm.year,
      };
      Axios.postMasters(data)
        .then((response) => {
          this.showHideLoading();
          this.catching = false;
          this.nCatching = 0;
          this.catchingData.data = [];
          SweetAlert.success(
            response.data.message ? response.data.message : response.errors
          );
        })
        .catch((error) => {
          console.log(error);
          this.showHideLoading();
        });
    },

    validateData() {
      let band = true;
      this.catchingData.data.forEach((data, index) => {
        if (
          data.area_podar != null &&
          data.area_podar != '' &&
          data.area_podar != 0
        ) {
          if (data.variety == null) {
            let sel = document.getElementById(`variety${index}`);
            sel.classList.add('custom-has-error');
            // store.dispatch("utils/removeHasError", sel);
            band = false;
          }

          if (data.pocket_week == null) {
            let sel = document.getElementById(`pocket_week${index}`);
            sel.classList.add('custom-has-error');
            // store.dispatch("utils/removeHasError", sel);
            band = false;
          }

          if (data.production_week == null) {
            let sel = document.getElementById(`production_week${index}`);
            sel.classList.add('custom-has-error');
            // store.dispatch("utils/removeHasError", sel);
            band = false;
          }
        }
      });
      if (band) {
        this.storeCatching();
      }
    },

    onSelectLot(event, i) {
      let area_ocupada = 0.0;

      let oldLot = this.catchingData.data.find(
        (lot) => lot.lot_name == event.name
      );

      this.catchingData.data[i].area_disponible = oldLot.area_disponible;
      this.catchingData.data[i].area_disponible_aux =
        oldLot.area_disponible_aux;
      this.catchingData.data[i].area_lote = oldLot.area_lote;
      this.catchingData.data[i].area_podar = 0;
      this.catchingData.data[i].farm_id = oldLot.farm_id;
      this.catchingData.data[i].farm_name = oldLot.farm_name;
      this.catchingData.data[i].lot_id = oldLot.lot_id;
      this.catchingData.data[i].lot_name = oldLot.lot_name;
      this.catchingData.data[i].pruning_week = oldLot.pruning_week;

      this.catchingData.data.forEach((lote) => {
        if (lote.lot_name == event.name && lote.area_podar != null) {
          area_ocupada += Number.parseFloat(lote.area_podar);
        }
      });

      let disponible = this.catchingData.data[i].area_lote - area_ocupada;

      if (disponible % 2 != 0) {
        this.catchingData.data[i].area_disponible_aux = `${disponible}.0`;
      } else {
        this.catchingData.data[i].area_disponible_aux = disponible;
      }
    },

    onChangeAreaInput(area, i, name) {
      let area_podar = 0;
      area = Number.parseFloat(area);

      for (let j = 0; j < this.catchingData.data.length; j++) {
        if (
          this.catchingData.data[j].lot_name == name &&
          this.catchingData.data[j].area_podar != null &&
          this.catchingData.data[j].area_podar != '' &&
          this.catchingData.data[j].area_podar != 0
        ) {
          area_podar += Number.parseFloat(this.catchingData.data[j].area_podar);
        }
      }

      for (let j = 0; j < this.catchingData.data.length; j++) {
        if (this.catchingData.data[j].lot_name == name) {
          this.catchingData.data[j].area_disponible_aux =
            this.catchingData.data[j].area_disponible - area_podar;
        }
      }
    },

    fullPruning(value, index, name) {
      if (value == 'SI') {
        this.catchingData.data[index]['areaDisabled'] = true;
        this.catchingData.data[index].area_podar =
          this.catchingData.data[index]['area_disponible'];
        this.catchingData.data[index]['area_disponible_aux'] = 0;
        // this.catchingData.data[index].area_disponible = 0;

        for (let i = 0; i < this.catchingData.data.length; i++) {
          if (this.catchingData.data[i].lot_name == name) {
            this.catchingData.data[i].area_podar =
              this.catchingData.data[i]['area_disponible'];
            this.catchingData.data[i]['area_disponible_aux'] = 0;
            this.catchingData.data[i]['areaDisabled'] = true;
            this.catchingData.data[i].poda_completa = 'SI';
          }
        }
      } else if (value == 'NO') {
        this.catchingData.data[index]['areaDisabled'] = false;
        this.catchingData.data[index].area_podar = null;
        this.catchingData.data[index]['area_disponible_aux'] =
          this.catchingData.data[index]['area_disponible'];
        // this.catchingData.data[index].area_disponible = 0;

        for (let i = 0; i < this.catchingData.data.length; i++) {
          if (this.catchingData.data[i].lot_name == name) {
            this.catchingData.data[i].area_podar = null;
            this.catchingData.data[i]['area_disponible_aux'] =
              this.catchingData.data[index]['area_disponible'];
            this.catchingData.data[i]['areaDisabled'] = false;
            this.catchingData.data[i].poda_completa = 'NO';
          }
        }
      }
    },

    loadPruning() {
      this.showHideLoading(true);
      let date =
        parseInt(this.catchingForm.year) * 100 +
        parseInt(this.catchingForm.week);

      Promise.all([
        Axios.getMasters(
          `pruning/catching/${date}/${this.catchingForm.farm_id}`
        ),
        Axios.getMasters('farms/farms/lots/' + this.catchingForm.farm_id),
      ])
        .then((responses) => {
          this.catchingData.data = responses[0].data.data;
          let numData = responses[0].data.data.filter(
            (lot) => lot.pruning_area != 0
          ).length;
          numData > 0 ? (this.nCatching = numData) : (this.nCatching = 1);
          this.lots = responses[1].data.data;
          this.showHideLoading();
          this.catching = true;
        })
        .catch((error) => {
          console.log(error);
          this.showHideLoading();
        });
    },
  },
  created() {
    if (this.isIndex()) {
      this.showHideLoading(true);
      Promise.all([
        Axios.getMasters('farms/farms/only'),
        Axios.getMasters('cropvarieties'),
        Axios.getMasters('pruning/reasons'),
      ])
        .then((responses) => {
          this.farms = responses[0].data.data;
          this.varieties = responses[1].data.data;
          this.reasons = responses[2].data.data;
          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
        });

      this.catchingForm.week = new moment().format('w');

      let nextYear = new moment().add(1, 'years').format('YYYY');
      this.catchingForm.year = Number.parseInt(nextYear) - 1;

      for (let i = 0; i < 4; i++) {
        this.years.push(
          new moment(nextYear).subtract(i, 'years').format('YYYY')
        );
      }

      this.weeks = [...Array(54).keys()].slice(1);
    }
  },

  mounted() {
    this.selectedItemOnMenu('pruning/reasons');
  },

  beforeDestroy() {
    this.deselectedItemOnMenu('pruning/reasons');
  },
};
</script>

<style scoped>
.custom-overflow {
  overflow-x: auto;
}
.custom-flex {
  display: flex;
  justify-content: center;
}
</style>
